// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2tLxX","inputWrap":"CustomTip_inputWrap__2mJm2"};